import { addDays as addDaysFns, addHours as addHoursFns, addMinutes as addMinutesFns, addMonths as addMonthsFns, addWeeks as addWeeksFns, addYears as addYearsFns, differenceInDays as differenceInDaysFns, differenceInHours as differenceInHoursFns, differenceInMilliseconds as differenceInMillisecondsFns, differenceInMinutes as differenceInMinutesFns, differenceInMonths as differenceInMonthsFns, differenceInWeeks as differenceInWeeksFns, endOfDay as endOfDayFns, endOfHour as endOfHourFns, endOfMonth as endOfMonthFns, intervalToDuration as intervalToDurationFns, startOfDay as startOfDayFns, startOfHour as startOfHourFns, startOfMonth as startOfMonthFns, subDays as subDaysFns, subHours as subHoursFns, subMinutes as subMinutesFns, subMonths as subMonthsFns, subWeeks as subWeeksFns, subYears as subYearsFns, } from "date-fns";
/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {number}
 */
const differenceInMilliseconds = (date1, date2) => {
    return differenceInMillisecondsFns(date1, date2);
};
/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {number}
 */
const differenceInMinutes = (date1, date2) => {
    return differenceInMinutesFns(date1, date2);
};
/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {number}
 */
const differenceInHours = (date1, date2) => {
    return differenceInHoursFns(date1, date2);
};
/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {number}
 */
const differenceInDays = (date1, date2) => {
    return differenceInDaysFns(date1, date2);
};
/**
 * @param {Date | number} date
 * @param {number} days
 * @returns {Date}
 */
const addDays = (date, days) => {
    return addDaysFns(date, days);
};
/**
 * @param {Date | number} date
 * @param {number} hours
 * @returns {Date}
 */
const addHours = (date, hours) => {
    return addHoursFns(date, hours);
};
/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {number}
 */
const differenceInWeeks = (date1, date2) => {
    return differenceInWeeksFns(date1, date2);
};
/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {number}
 */
const differenceInMonths = (date1, date2) => {
    return differenceInMonthsFns(date1, date2);
};
/**
 * @param {Date | number} date
 * @param {number} years
 * @returns {Date}
 */
const addYears = (date, years) => {
    return addYearsFns(date, years);
};
/**
 * @param {Date | number} date
 * @param {number} weeks
 * @returns {Date}
 */
const addMonths = (date, months) => {
    return addMonthsFns(date, months);
};
/**
 * @param {Date | number} date
 * @param {number} weeks
 * @returns {Date}
 */
const addWeeks = (date, weeks) => {
    return addWeeksFns(date, weeks);
};
/**
 * @param {Date | number} date
 * @param {number} minutes
 * @returns {Date}
 */
const addMinutes = (date, minutes) => {
    return addMinutesFns(date, minutes);
};
/**
 * @param {Date | number} date
 * @param {number} years
 * @returns {Date}
 */
const subYears = (date, years) => {
    return subYearsFns(date, years);
};
/**
 * @param {Date | number} date
 * @param {number} months
 * @returns {Date}
 */
const subMonths = (date, months) => {
    return subMonthsFns(date, months);
};
/**
 * @param {Date | number} date
 * @param {number} weeks
 * @returns {Date}
 */
const subWeeks = (date, weeks) => {
    return subWeeksFns(date, weeks);
};
/**
 * @param {Date | number} date
 * @param {number} days
 * @returns {Date}
 */
const subDays = (date, days) => {
    return subDaysFns(date, days);
};
/**
 * @param {Date} date
 * @param {number} hours
 * @returns {Date}
 */
const subHours = (date, hours) => {
    return subHoursFns(date, hours);
};
/**
 * @param {Date | number} date
 * @param {number} minutes
 * @returns {Date}
 */
const subMinutes = (date, minutes) => {
    return subMinutesFns(date, minutes);
};
/**
 * @param {Date | number} date
 * @returns {Date}
 */
const startOfDay = (date) => {
    return startOfDayFns(date);
};
/**
 * @param {Date | number} date
 * @returns {Date}
 */
const endOfDay = (date) => {
    return endOfDayFns(date);
};
/**
 * @param {Date | number} date
 * @returns {Date}
 */
const startOfMonth = (date) => {
    return startOfMonthFns(date);
};
/**
 * @param {Date | number} date
 * @returns {Date}
 */
const endOfMonth = (date) => {
    return endOfMonthFns(date);
};
/**
 * @param {Date | number} date
 * @returns {Date}
 */
const startOfHour = (date) => {
    return startOfHourFns(date);
};
/**
 * @param {Date | number} date
 * @returns {Date}
 */
const endOfHour = (date) => {
    return endOfHourFns(date);
};
/**
 * @param {Date} date1
 * @param {Date} date2
 * @returns {Duration}
 */
const intervalToDuration = (date1, date2) => {
    return intervalToDurationFns({ start: date1, end: date2 });
};
export { differenceInMilliseconds, differenceInMinutes, differenceInHours, differenceInDays, differenceInWeeks, differenceInMonths, addDays, addHours, addMinutes, addMonths, addWeeks, addYears, subDays, subHours, subMinutes, subMonths, subWeeks, subYears, startOfHour, startOfDay, startOfMonth, endOfHour, endOfDay, endOfMonth, intervalToDuration, };
